var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBlockplayerPosterImg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15v3h3v2h-3v3h-2v-3h-3v-2h3v-3h2zm.008-12c.548 0 .992.445.992.993V13h-2V5H4v13.999L14 9l3 3v2.829l-3-3L6.827 19H14v2H2.992A.993.993 0 012 20.007V3.993A1 1 0 012.992 3h18.016zM8 7a2 2 0 110 4 2 2 0 010-4z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ij48cGF0aCBmaWxsPSJub25lIiBkPSJNMCAwaDI0djI0SDB6Ii8+PHBhdGggZD0iTTIxIDE1djNoM3YyaC0zdjNoLTJ2LTNoLTN2LTJoM3YtM2gyem0uMDA4LTEyYy41NDggMCAuOTkyLjQ0NS45OTIuOTkzVjEzaC0yVjVINHYxMy45OTlMMTQgOWwzIDN2Mi44MjlsLTMtM0w2LjgyNyAxOUgxNHYySDIuOTkyQS45OTMuOTkzIDAgMCAxIDIgMjAuMDA3VjMuOTkzQTEgMSAwIDAgMSAyLjk5MiAzaDE4LjAxNnpNOCA3YTIgMiAwIDEgMSAwIDQgMiAyIDAgMCAxIDAtNHoiLz48L3N2Zz4=";
export { SvgBlockplayerPosterImg as ReactComponent };